import { useState } from 'react';
import { avatarColor, initialsOf } from '@/utils/outreach';

interface MemberAvatarProps {
  memberId: string;
  name: string;
  photoURL?: string;
  size?: number;
}

/** Photo when there is one, otherwise coloured initials (colour is stable per member). */
export function MemberAvatar({ memberId, name, photoURL, size = 40 }: MemberAvatarProps) {
  const [broken, setBroken] = useState(false);
  const showPhoto = !!photoURL && !broken;
  return (
    <div
      className="rounded-full shrink-0 flex items-center justify-center text-white font-semibold overflow-hidden"
      style={{
        width: size,
        height: size,
        background: showPhoto ? '#e2e8f0' : avatarColor(memberId),
        fontSize: Math.round(size * 0.38),
      }}
      aria-hidden="true"
    >
      {showPhoto ? (
        <img
          src={photoURL}
          alt=""
          className="w-full h-full object-cover"
          referrerPolicy="no-referrer"
          onError={() => setBroken(true)}
        />
      ) : (
        initialsOf(name)
      )}
    </div>
  );
}
